import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "500px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${theme.spacing(2.5)} ${theme.spacing(2)}`,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  contactHostTitle: {
    lineHeight: "20px",
  },
  closeButton: {
    padding: 0,
  },
  icons: {
    marginRight: theme.spacing(1.5),
  },
  channels: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.25),
  },
  divider: {
    margin: `${theme.spacing(2.5)} 0`,
  },
  details: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.25),
  },
  detail: {
    fontSize: "16px",
  },
  dialogContent: {
    padding: `${theme.spacing(2.5)} !important`,
  },
  actionButtonContent: {
    padding: `0 ${theme.spacing(2)}`,
  },
  title: {
    fontSize: "16px",
    fontWeight: 800,
  },
}));
